import { DatePickerClasses } from '../../../../uicomponents/src/date-picker/date-picker-classes';

export class FormField {
    get isValid(): boolean {
        return this.base.classList.contains(DatePickerClasses.IsValid);
    }

    get isInvalid(): boolean {
        return this.base.classList.contains(DatePickerClasses.IsInvalid);
    }

    get isTouched(): boolean {
        return this.base.classList.contains(DatePickerClasses.IsTouched);
    }

    get isUntouched(): boolean {
        return !this.isTouched;
    }

    get isPristine(): boolean {
        return !this.isTouched;
    }

    constructor(public base: HTMLInputElement) {}

    setTouched(): void {
        (window as any)['htmx'].addClass(
            this.base,
            DatePickerClasses.IsTouched
        );
    }

    setValidity(isValid: boolean, invalidityMessage?: string): void {
        if (isValid) {
            (window as any)['htmx'].addClass(
                this.base,
                DatePickerClasses.IsValid
            );
            (window as any)['htmx'].removeClass(
                this.base,
                DatePickerClasses.IsInvalid
            );

            this.base.setCustomValidity('');
        } else {
            (window as any)['htmx'].addClass(
                this.base,
                DatePickerClasses.IsInvalid
            );
            (window as any)['htmx'].removeClass(
                this.base,
                DatePickerClasses.IsValid
            );

            this.base.setCustomValidity(
                invalidityMessage ?? 'Field is invalid'
            );
        }
    }
}
